import * as yup from 'yup';

yup.setLocale({
  mixed: {
    required: 'Campo obrigatório',
  },
  string: {
    // eslint-disable-next-line no-template-curly-in-string
    min: 'O campo deve ter no mínimo ${min} caracteres',
  }
});

const schemaPassword = yup.object().shape({
  password: yup
    .string()
    .required()
    .min(8)
    .test(
      'strong-password',
      'A senha não cumpre os requisitos, veja abaixo:',
      (value = '') => {
        if (
          value.match(/[0-9]+/g) &&
          value.match(/[A-Z]+/g) &&
          value.match(/[a-z]+/g)
        ) {
          return true;
        }

        return false;
      }
    ),
  password_confirmation: yup
    .string()
    .required()
    .oneOf([yup.ref('password')], 'Senhas não conferem'),
});

export default schemaPassword;
